import { useCallback, useEffect, useState } from 'react'

import { Loading } from 'components/ui/Loading/Loading'
import {
  Cargo,
  useContainers,
  useContainersActions,
} from 'services/warehouse-containers/containers'
import { ContainerItem } from 'components/ContainerItem/ContainerItem'
import { Slider } from 'components/ui/Slider/Slider'
import { Button } from 'components/ui/Button/Button'
import { Filter } from './components/Filter/Filter'
import { Warehouse, WarehouseType } from 'services/warehouse-containers/warehouse'
import { Place } from 'components/Place/Place'

import './inspect.style.css'

export const Inspect = () => {
  const [selectedCargo, setSelectedCargo] = useState<Cargo>(null)
  const [warehouseFound, setWarehouseFound] = useState<boolean>(false)
  const [isActive, setIsActive] = useState<boolean>(false)

  const {
    isLoading,
    setFilters,
    setArgs,
    args,
    reset,
    containers: containerList,
    refreshValues,
  } = useContainers()
  const { isLoading: isActionProcessing, inspectContainers } = useContainersActions()

  useEffect(() => () => reset(), [])

  const renderCargoItem = useCallback((el: Cargo, index: number) => {
    const handleOnSubmit = (cargo: Cargo) => {
      setSelectedCargo(cargo)
      setIsActive(true)
    }

    return (
      <ContainerItem
        key={index}
        buttonText="Проверено"
        element={el}
        onSubmut={handleOnSubmit}
      ></ContainerItem>
    )
  }, [])

  const renderCargoList = useCallback(() => {
    if (isLoading || isActionProcessing) return <Loading />

    return <div className="inspect-page-list">{containerList?.map(renderCargoItem)}</div>
  }, [isLoading, isActionProcessing, containerList])

  const renderFilter = useCallback(() => {
    if (!warehouseFound) return null

    const handleOnProductChange = (products: string[]) => {
      setFilters((currValue) => ({ ...currValue, products }))
    }

    const handleOnIntervalChange = (interval: [Date, Date]) => {
      setFilters((currValue) => ({ ...currValue, interval }))
    }

    const handleOnOrderNumberChange = (orderNumber: number) => {
      setFilters((currValue) => ({ ...currValue, orderNumber }))
    }

    const handleOnCotnainerSealChange = (containerSeal: number) => {
      setFilters((currValue) => ({ ...currValue, containerSeal }))
    }

    const handleOnDeliveryTypeChange = (deliveryType: number) => {
      setFilters((currValue) => ({ ...currValue, deliveryType }))
    }

    return (
      <Filter
        onIntervalChange={handleOnIntervalChange}
        onProductsChange={handleOnProductChange}
        onDeliveryTypeChange={handleOnDeliveryTypeChange}
        onOrderNumberChange={handleOnOrderNumberChange}
        onContainerSealChange={handleOnCotnainerSealChange}
      />
    )
  }, [warehouseFound])

  const handleOnSearch = (warehouse: Warehouse) => {
    setArgs(warehouse)
    setWarehouseFound(true)
  }

  const handleOnClose = () => setIsActive(false)

  const handleOnSubmut = async () => {
    const containerIds = selectedCargo?.containers?.map((el) => el.id)

    setIsActive(false)

    await inspectContainers(selectedCargo?.id, containerIds)

    refreshValues()
  }

  return (
    <>
      <Place
        title="Проверка"
        hint="Поиск контейнеров осуществляется после указания места проверки..."
        warehouse={args}
        onSearch={handleOnSearch}
        warehouseTypes={[WarehouseType.MiniWarehouse, WarehouseType.Courier]}
      />
      {renderFilter()}
      {renderCargoList()}
      <Slider isActive={isActive} onClose={handleOnClose} height="150px">
        <div className="transfer-page-list__slider">
          <h2>Контейнеры #{selectedCargo?.orderNumber} проверены?</h2>
          <div className="transfer-page-list__slider-controlls">
            <span style={{ marginRight: '0.5rem' }}>
              <Button title="Проверено" handleOnSubmit={handleOnSubmut} />
            </span>
            <Button outline title="Отмена" handleOnSubmit={handleOnClose} />
          </div>
        </div>
      </Slider>
    </>
  )
}
